export default [
  {
    path: '/overview',
    name: 'overview',
    component: () => import(/* webpackChunkName: "overview" */ './overview/overview.vue'),
    meta: {
      menuCode: 'pcManageReport',
      globalCampus: 'multiple',
      noCache: true,
      menuName: '经营数据概览',
    },
  },
  {
    path: '/student-report',
    name: 'student-report',
    component: () => import(/* webpackChunkName: "student-report" */ './student-report/student-report.vue'),
    meta: {
      menuCode: 'pcStudentReport',
      menuName: '学员数据分析',
    },
  },
  {
    path: '/teacher-report',
    name: 'teacher-report',
    component: () => import(/* webpackChunkName: "teacher-report" */ './teacher-report/teacher-report.vue'),
    meta: {
      menuCode: 'pcTeacherIncomeReport',
      menuName: '老师业绩分析',
    },
  },
  {
    path: '/teacher-pay-detail',
    name: 'teacher-pay-detail',
    component: () => import(/* webpackChunkName: "teacher-pay-detail" */ './teacher-report/teacher-pay-detail.vue'),
    meta: {
      menuName: '老师签单业绩详情',
    },
  },
  {
    path: '/feiyong-detail',
    name: 'feiyong-detail',
    component: () => import(/* webpackChunkName: "feiyong-detail" */ './feiyong-detail/feiyong-detail.vue'),
    meta: {
      // noCache: true,
      menuCode: 'pcFeeReport',
      menuName: '费用数据分析',
    },
  },
  {
    path: '/comment-report',
    name: 'comment-report',
    component: () => import(/* webpackChunkName: "comment-report" */ './comment-report/comment-report.vue'),
    meta: {
      menuCode: 'pcQandaCommentReport',
      menuName: '家校数据分析',
    },
  },
  {
    path: '/attendance-summary',
    name: 'attendance-summary',
    component: () => import(/* webpackChunkName: "attendance-summary" */ './jiaowu-report/attendance-summary.vue'),
    meta: {
      menuCode: 'pcEduReport',
      menuName: '教务数据分析',
    },
  },

  {
    path: '/attendance-detail',
    name: 'attendance-detail',
    component: () => import(/* webpackChunkName: "attendance-detail" */ './jiaowu-report/attendance-detail.vue'),
    meta: {
      cachePage: ['/attendance-summary'],
    },
  },
  {
    path: '/clues-report',
    name: 'clues-detail',
    component: () => import(/* webpackChunkName: "attendance-detail" */ './clues-report/clues-report.vue'),
    meta: {
      menuCode: 'pcRecruitReport',
      cachePage: ['/clues-report'],
      menuName: '招生数据分析',
    },
  },
  {
    path: '/student-report-detail',
    name: 'student-report-detail',
    component: () => import(/* webpackChunkName: "attendance-detail" */ './clues-report/children/student-report-detail.vue'),
    meta: {
      menuCode: '',
      cachePage: ['/clues-report'],
    },
  },
  {
    path: '/introduce-report-detail',
    name: 'introduce-report-detail',
    component: () => import(/* webpackChunkName: "attendance-detail" */ './clues-report/children/introduce-report-detail.vue'),
    meta: {
      menuCode: '',
      cachePage: ['/clues-report'],
    },
  },
];
